import { useState } from 'react';
import { date } from 'yup';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Divider,
  Grid,
  IconButton,
  Select,
  Stack,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography
} from '@mui/material';
import { useEffect } from 'react';
import { ArrowDropDown, ArrowDropUp } from '@mui/icons-material';
import useAuth from 'app/hooks/useAuth';
import { collection, doc, getFirestore, onSnapshot } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// const data = {
//   key_abcsadasdasd: {
//     inTime: Date.now(),
//     title: 'Title 1 zxc v xcv z xc v xcv zx cv zx cvzxcv',
//     link: 'https://www.google.com/xcvx/cv/zxcv/zxc/v/zxc/v/xc/vxzcv',
//     siteId: 'siteId1',
//     midjourney_key: 'abcs'
//   },
//   key_abcsa222dasdasd: {
//     inTime: Date.now(),
//     title: 'Title 2 sdfasdfasdfasdfasdf',
//     link: 'https://www.google.com/ZXCV/ZXCV/ZXCV/ZXCV/ZXCV/ZXCV/ZXCV',
//     siteId: 'siteId2',
//     midjourney_key: 'abcs'
//   },
//   key_abcs22dasdasd: {
//     inTime: Date.now(),
//     title: 'Title 2 sdfasdfasdfasdfasdf',
//     link: 'https://www.google.com/ZXCV/ZXCV/ZXCV/ZXCV/ZXCV/ZXCV/ZXCV',
//     siteId: 'siteId2',
//     midjourney_key: 'abcs'
//   },

//   key_abcsa222ddasd: {
//     inTime: Date.now(),
//     title: 'Title 2 sdfasdfasdfasdfasdf',
//     link: 'https://www.google.com/ZXCV/ZXCV/ZXCV/ZXCV/ZXCV/ZXCV/ZXCV',
//     siteId: 'siteId2',
//     midjourney_key: 'abcs'
//   },

//   key_abcsa222dasd: {
//     inTime: Date.now(),
//     title: 'Title 2 sdfasdfasdfasdfasdf',
//     link: 'https://www.google.com/ZXCV/ZXCV/ZXCV/ZXCV/ZXCV/ZXCV/ZXCV',
//     siteId: 'siteId2',
//     midjourney_key: 'abcs'
//   },

//   total_processed: {
//     abcsadasdasd: 2,
//     abcsa222dasdasd: 1
//   },
//   time: Date.now()
// };

const formatTime = (time) => {
  const seconds = Math.floor((time / 1000) % 60);
  const minutes = Math.floor((time / (1000 * 60)) % 60);
  const hours = Math.floor((time / (1000 * 60 * 60)) % 24);
  const days = Math.floor(time / (1000 * 60 * 60 * 24));

  if (!days) {
    if (!hours) {
      if (!minutes) {
        return `${seconds}s`;
      }
      return `${minutes}m ${seconds}s`;
    }
    return `${hours}h ${minutes}m ${seconds}s`;
  }

  return `${days}d ${hours}h ${minutes}m ${seconds}s`;
};
const QueueStat = ({ sites }) => {
  const [queueItems, setQueueItems] = useState([]);
  const [countBySite, setCountBySite] = useState({});
  const [selectedSite, setSelectedSite] = useState(null);
  const [accordianOpen, setAccordianOpen] = useState(true);
  const [data, setData] = useState({});
  const [now_time, setNowTime] = useState(Date.now());

  useEffect(() => {
    const interval = setInterval(() => {
      setNowTime(Date.now());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const unsub = onSnapshot(
      doc(getFirestore(), 'queues', getAuth().currentUser.uid),
      (snapshot) => {
        if (snapshot.exists()) {
          setData(snapshot.data());
        }
      }
    );
    return () => unsub();
  }, []);

  useEffect(() => {
    const qItems = Object.keys(data)
      .filter((key) => {
        return key.startsWith('key_');
      })
      .map((key) => {
        if (!selectedSite || data[key].siteId === selectedSite) {
          return {
            inTime: data[key].inTime,
            title: data[key].title,
            link: data[key].link,
            siteId: data[key].siteId
          };
        }
        return null;
      })
      .filter((item) => item !== null);

    const d = qItems.reduce((acc, item) => {
      acc[item.siteId] = acc[item.siteId] || 0;
      acc[item.siteId]++;
      return acc;
    }, {});

    d.items_in_queue = Object.keys(data).reduce((acc, key) => {
      if (key.startsWith('key_')) {
        acc++;
      }
      return acc;
    }, 0);
    d.total_processed = Object.keys(data?.total_processed || {}).reduce((acc, key) => {
      acc += data.total_processed[key];
      return acc;
    }, 0);
    d.detailed_processed = data?.total_processed || {};
    d.time = data?.time || Date.now();
    d.totalAttempts = data?.totalAttempts || 0;
    setQueueItems(qItems);
    setCountBySite(d);
  }, [data, selectedSite]);

  return (
    <Accordion
      style={{
        border: 0,
        margin: 0
      }}
      defaultExpanded
      expanded={accordianOpen}
      onChange={() => setAccordianOpen(!accordianOpen)}
    >
      <AccordionSummary>
        <Stack direction="row" justifyContent="space-between" width="100%" alignItems="center">
          <Typography variant="h6">Queue Statistics</Typography>

          {!accordianOpen && (
            <Stack direction="row" alignItems="center" gap={2}>
              <Typography variant="body2">
                Total {countBySite.total_processed} post(s) were processed successfully on{' '}
                {new Date(countBySite.time || Date.now()).toLocaleDateString()}
              </Typography>
              |
              <Typography variant="body2">
                {countBySite.items_in_queue} item(s) still in queue
              </Typography>
            </Stack>
          )}
          <IconButton onClick={() => setAccordianOpen(!accordianOpen)}>
            {!accordianOpen ? <ArrowDropDown /> : <ArrowDropUp />}
          </IconButton>
        </Stack>
      </AccordionSummary>
      <AccordionDetails
        style={{
          border: 'none',
          minHeight: '30vh',
          marginBottom: '15px'
        }}
      >
        <Grid container spacing={2} justifyContent="space-between" height="100%">
          <Grid item xs={12} md={5}>
            <Stack gap={2} width="100%" height="100%">
              <Typography
                variant="body1"
                color="GrayText"
                style={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }}
              >
                Select Site to view detailed statistics
              </Typography>
              {sites && (
                <Autocomplete
                  size="small"
                  fullWidth
                  id="tags-outlined"
                  options={sites}
                  getOptionLabel={(option) =>
                    option.url.replace('https://', '').replace('/wp-json', '')
                  }
                  filterSelectedOptions
                  onChange={(e, value) => setSelectedSite(value?.id || null)}
                  renderInput={(params) => (
                    <TextField
                      fullWidth
                      {...params}
                      variant="outlined"
                      placeholder="Select Sites"
                    />
                  )}
                />
              )}

              <Stack gap={2}>
                <Typography variant="body2">
                  Queue report for {new Date(countBySite.time || Date.now()).toLocaleDateString()}
                </Typography>
                <ul>
                  <li>
                    <Typography variant="body2">
                      Total{' '}
                      <b>
                        {selectedSite
                          ? countBySite.detailed_processed[selectedSite] || 0
                          : countBySite.total_processed}{' '}
                        post(s)
                      </b>{' '}
                      were processed successfully
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="body2">
                      <b>{queueItems.length} item(s)</b> in queue
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="body2">
                      <b>{countBySite.totalAttempts} posts(s)</b> were submitted to the queue from
                      all sites
                    </Typography>
                  </li>
                </ul>
              </Stack>
            </Stack>
          </Grid>
          <Grid item xs={12} md={6}>
            <TableContainer style={{ maxHeight: '30vh', overflow: 'auto' }}>
              <Table width="100%" style={{ padding: '10px' }}>
                <TableHead>
                  <TableRow>
                    <TableCell>Posts in Queue ({queueItems.length})</TableCell>
                    <TableCell align="right">Time In Queue</TableCell>
                  </TableRow>
                </TableHead>
                {queueItems.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      <Stack>
                        <Typography
                          variant="body1"
                          style={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                          }}
                        >
                          {item.title}
                        </Typography>
                        <Typography
                          variant="body2"
                          color="GrayText"
                          style={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            cursor: 'pointer'
                          }}
                          onClick={() => window.open(item.link)}
                        >
                          {item.link}
                        </Typography>
                      </Stack>
                    </TableCell>

                    <TableCell align="right">
                      <Typography variant="body2">{formatTime(now_time - item.inTime)}</Typography>
                    </TableCell>
                  </TableRow>
                ))}
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default QueueStat;
